export interface IProbeRTCTest {
  name: string;
  title: string;
  tooltip: string;
  link: string;
}

export type TestName =
  | "CallQuality"
  | "TurnConnectivity"
  | "Location"
  | "Ping"
  | "Throughput"
  | "BandwidthSpeed"
  | "DNSLookup"
  | "RCVTURNServers"
  | "VideoBandwidth"
  | "NetworkInformation"
  | "VideoQuality"
  | "Traceroute";

export const ProbeRTCTests: { [name in TestName]: IProbeRTCTest } = {
  CallQuality: {
    name: "CallQuality",
    title: "Call Quality",
    tooltip: "Call Quality",
    link: "https://support.testrtc.com/hc/en-us/articles/8428313759631-CALL-QUALITY-widget/",
  },
  TurnConnectivity: {
    name: "TurnConnectivity",
    title: "Turn Connectivity",
    tooltip: "Turn Connectivity",
    link: "https://support.testrtc.com/hc/en-us/articles/8428345269263-TURN-CONNECTIVITY-widget/",
  },
  Location: {
    name: "Location",
    title: "Location",
    tooltip: "Location",
    link: "https://support.testrtc.com/hc/en-us/articles/8428313816591-LOCATION-widget/",
  },
  Ping: {
    name: "Ping",
    title: "Ping",
    tooltip: "Ping",
    link: "https://support.testrtc.com/hc/en-us/articles/8428324079631-PING-widget/",
  },
  Throughput: {
    name: "Throughput",
    title: "Throughput",
    tooltip: "Throughput",
    link: "https://support.testrtc.com/hc/en-us/articles/8428299861903-THROUGHPUT-widget/",
  },
  BandwidthSpeed: {
    name: "BandwidthSpeed",
    title: "Bandwidth Speed",
    tooltip: "Bandwidth Speed",
    link: "https://support.testrtc.com/hc/en-us/articles/8428324038671-BANDWIDTH-SPEED-widget/",
  },
  DNSLookup: {
    name: "DNSLookup",
    title: "DNS Lookup",
    tooltip: "DNS Lookup",
    link: "https://support.testrtc.com/hc/en-us/articles/8428300056847-DNS-LOOKUP-widget/",
  },
  RCVTURNServers: {
    name: "RCVTURNServers",
    title: "RCV Turn Servers",
    tooltip: "RCV Turn Servers",
    link: "https://support.testrtc.com/hc/en-us/articles/8428345269263-TURN-CONNECTIVITY-widget/",
  },
  VideoBandwidth: {
    name: "VideoBandwidth",
    title: "Video Bandwidth",
    tooltip: "Video Bandwidth",
    link: "https://support.testrtc.com/hc/en-us/articles/8428329568143-VIDEO-BANDWIDTH-widget/",
  },
  NetworkInformation: {
    name: "NetworkInformation",
    title: "Network Information",
    tooltip: "NetworkInformation",
    link: "",
  },
  VideoQuality: {
    name: "VideoQuality",
    title: "Video Quality",
    tooltip: "Video Quality",
    link: "https://support.testrtc.com/hc/en-us/articles/8428284102927-VIDEO-QUALITY-widget/",
  },

  Traceroute: {
    name: "Traceroute",
    title: "Traceroute",
    tooltip: "Traceroute",
    link: "",
  },
};

export const DefaultNormalTestList = [
  ProbeRTCTests.CallQuality.name,
  ProbeRTCTests.TurnConnectivity.name,
  ProbeRTCTests.Location.name,
  ProbeRTCTests.Ping.name,
];
export const DefaultThoroughTestList = [
  ProbeRTCTests.CallQuality.name,
  ProbeRTCTests.TurnConnectivity.name,
  ProbeRTCTests.Location.name,
  ProbeRTCTests.Ping.name,
  ProbeRTCTests.Throughput.name,
];
